import { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { EuiFormRow } from '@elastic/eui'

import { LocationTargetingType, LocationTargetingTypeToLocationType } from '../../../../../api/interfaces/CampaignTargeting'
import { useUpdateCampaignLocationTargetingMutation } from '../../../../../api/rtkQueryApi/platform/campaignsApi'
import { showSuccessToast } from '../../../../../app/appSlice'
import { RootState } from '../../../../../app/rootReducer'
import { LocationTargetingForm } from '../../../../../components/targeting/TargetingForm/LocationTargetingForm'
import { GetAudienceTargeting, GetLocationTargeting } from '../../../../../utils/CampaignFormatter'
import { DEFAULT_LOCATION_TARGETING } from '../../../../../utils/TargetingFormDefaults'
import { fetchCampaign } from '../../campaignSlice'
import { useCampaignEdit } from '../CampaignEditContext'

export const EditAudioLocationTargeting = () => {
  const { campaign } = useSelector((state: RootState) => state.campaign)

  const [locationTargeting, setLocationTargeting] = useState(GetLocationTargeting(campaign ?? undefined))
  const locationTargetingOptions = [LocationTargetingType.USA, LocationTargetingType.Region, LocationTargetingType.DMA, LocationTargetingType.City, LocationTargetingType.Zip]
  const { currentAccount } = useSelector((state: RootState) => state.app)
  const [updateTargeting] = useUpdateCampaignLocationTargetingMutation()
  const [audienceTargeting, setAudienceTargeting] = useState(GetAudienceTargeting(campaign ?? undefined))
  const dispatch = useDispatch()
  const { registerSave, markDirty } = useCampaignEdit()

  useEffect(() => {
    if (campaign) {
      setLocationTargeting(GetLocationTargeting(campaign))
      setAudienceTargeting(GetAudienceTargeting(campaign))
    }
  }, [campaign])

  const onSave = useCallback(async () => {
    if (!campaign || !currentAccount) {
      return
    }
    updateTargeting({
      campaignId: campaign.id,
      accountId: currentAccount?.id,
      targeting: {
        locations: {
          countries: [],
          regions: locationTargeting.targetingType === LocationTargetingType.Region ? locationTargeting.regions ?? [] : [],
          dmas: locationTargeting.targetingType === LocationTargetingType.DMA ? locationTargeting.dmas ?? [] : [],
          cities: locationTargeting.targetingType === LocationTargetingType.City ? locationTargeting.cities ?? [] : [],
          postalCodes: locationTargeting.targetingType === LocationTargetingType.Zip ? locationTargeting.zips ?? [] : [],
          uploadedAudienceUrl: locationTargeting.uploadedAudienceUrl
        },
        geoCircles: [],
        geoRectangles: [],
        geoPolygons: [],
        geoFences: []
      },
      locationType: LocationTargetingTypeToLocationType(locationTargeting.targetingType),
      audience: {
        ageRanges: audienceTargeting.demographics?.ageRanges ?? [],
        genders: audienceTargeting.demographics?.genders ?? [],
        householdIncomes: audienceTargeting.demographics?.householdIncomes ?? [],
        thirdPartyAudiences: [],
        segments: audienceTargeting.segments ?? []
      }
    }).then(() => {
      dispatch(showSuccessToast('Saved targeting information'))
      dispatch(fetchCampaign(currentAccount.id, campaign.id))
    })
  }, [campaign, currentAccount, locationTargeting, audienceTargeting, updateTargeting, dispatch])

  useEffect(() => {
    registerSave('geoTargeting', onSave)
  }, [onSave, registerSave])

  return (
    <>
      <EuiFormRow label={'Choose Location Targeting Strategy'} fullWidth>
        <LocationTargetingForm
          includeLocationTypes={locationTargetingOptions}
          targetingDetails={locationTargeting ?? DEFAULT_LOCATION_TARGETING}
          setTargetingDetails={details => {
            setLocationTargeting(details)
            markDirty('geoTargeting')
          }}
        />
      </EuiFormRow>
    </>
  )
}
